import {formDataRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceCreateCustomers(params) {
    return await formDataRequest('customers/create', params);
}
export async function serviceUpdateCustomers(params) {
    return await formDataRequest('customers/update', params);
}

export async function serviceGetCustomers(params) {
    return await postRequest('customers', params);
}

export async function serviceGetCustomerDetail(params) {
    return await postRequest('customers/detail', params);
}

export async function serviceGetFullProfile(params){
    return await postRequest('/auth/full/profile',params);
}

export async function serviceGetUserPayments(params) {
    return await postRequest('/payments', params);
}

export async function serviceGetUserRewards(params) {
    return await postRequest('/rewards', params);
}

export async function serviceGetCustomerReservation(params) {
    return await postRequest('customers/reservations', params);
}

export async function serviceGetCustomerTransactions(params) {
    return await postRequest('customers/transactions', params);
}

export async function serviceCustomerChangeStatus(params) {
    return await postRequest('customers/change/status', params);
}

export async function serviceCustomerBankDetails(params) {
    return await postRequest('customers/bank/details', params);
}
export async function serviceDownloadCustomerExcel(params) {
    return await postRequest('/customers/download', params);
}

export async function serviceGetCustomerInviteCodes(params) {
    return await postRequest('customers/invite/codes', params);
}

export async function serviceCustomerVerifyIdentity(params) {
    return await postRequest('customers/verify/identity', params);
}

export async function serviceDeleteWorkImage(params){
    return await postRequest('/customers/delete/work/image', params);
}

export async function serviceGetCustomerRefferedUsers(params) {
    return await postRequest('customers/referred', params);
}
